<ng-container content>
  {{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.DESCRIPTION' | translate }}

  <ng-container *ngIf="duplicateConfigIsLoading$ | async; else showControls">
    <div class="loading-spinner">
      <mat-spinner [diameter]="80"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #showControls>
    <div class="settings-need-margin-top">&nbsp;</div>
    <mat-radio-group
      name="duplicateConfig"
      (change)="changeSettings($event.value)"
      class="dupe-options"
    >
      <span class="dupe-option">
        <mat-radio-button
          class="dupe-option__text"
          color="primary"
          [value]="dupeOptionsForTemplate.DUPLICATE_SETTINGS_USE_EMAIL"
          [checked]="
            (newDuplicateSettings$ | async) ===
            dupeOptionsForTemplate.DUPLICATE_SETTINGS_USE_EMAIL
          "
        >
          {{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_EMAIL' | translate }}
        </mat-radio-button>
      </span>
      <span class="dupe-option">
        <mat-radio-button
          class="dupe-option__text"
          color="primary"
          [value]="dupeOptionsForTemplate.DUPLICATE_SETTINGS_USE_PHONE"
          [checked]="
            (newDuplicateSettings$ | async) ===
            dupeOptionsForTemplate.DUPLICATE_SETTINGS_USE_PHONE
          "
        >
          {{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_PHONE' | translate }}
        </mat-radio-button>
      </span>
      <span class="dupe-option">
        <mat-radio-button
          class="dupe-option__text"
          color="primary"
          [value]="dupeOptionsForTemplate.DUPLICATE_SETTINGS_EITHER"
          [checked]="
            (newDuplicateSettings$ | async) ===
            dupeOptionsForTemplate.DUPLICATE_SETTINGS_EITHER
          "
        >
          {{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_EITHER' | translate }}
        </mat-radio-button>
        <mat-icon
          class="dupe-option__info"
          [matTooltip]="
            'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_EITHER_DETAILS'
              | translate
          "
          [matTooltipPosition]="'right'"
        >
          info
        </mat-icon>
      </span>
      <span class="dupe-option">
        <mat-radio-button
          class="dupe-option__text"
          color="primary"
          [value]="dupeOptionsForTemplate.DUPLICATE_SETTINGS_BOTH"
          [checked]="
            (newDuplicateSettings$ | async) ===
            dupeOptionsForTemplate.DUPLICATE_SETTINGS_BOTH
          "
        >
          {{ 'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_BOTH' | translate }}
        </mat-radio-button>
        <mat-icon
          class="dupe-option__info"
          [matTooltip]="
            'LEAD_INTEGRATIONS.SETTINGS.DUPLICATES.USE_BOTH_DETAILS' | translate
          "
          [matTooltipPosition]="'right'"
        >
          info
        </mat-icon>
      </span>
    </mat-radio-group>
  </ng-template>
</ng-container>
